<form [formGroup]="mdl_TripSAD" class="modal-body p-0">

    <div class="container">
        <div class="row">

            <div class="col-md-3"></div>
            <div class="col-md-6">
                <div class="central my-3">
                    <div class="d-flex justify-content-between align-items-center flex-column mb-4 profile_img">
                      
                        <input accept=".jpg" type="file" id="file" name="file" (change)="onFileSelected($event)"
                            style="display: none;">
                        <label (change)="onFileSelected($event)" for="file" 
                            class=" central pointer">
                            <img *ngIf="Info?.strAvatar" src="data:image/png;base64,{{selectedFile}}" alt="نمایه پروفایل">
                            <img *ngIf="!Info?.strAvatar" src="../../../assets/imgs/user_profile.png" alt="نمایه پروفایل">

                        </label>
                        <span class="mt-2 text-light">جهت ویرایش عکس پروفایل روی آن کلیک کنید</span>

                    </div>

                </div>

                <div class="central mb-3 form_box">
                    <div class="form-group w-100 has-icon">

                        <label class="text-muted m-0">نام </label>


                        <span class="form-control-icon">

                            <mat-icon class="mat-18">person</mat-icon>

                        </span>

                        <input formControlName="strName" class="form-control" type="text" placeholder=" ">

                    </div>

                    <div class="mx-1"></div>

                    <div class="form-group w-100 has-icon">

                        <label class="text-muted m-0"> نام خانوادگی </label>


                        <span class="form-control-icon">

                            <mat-icon class="mat-18">person</mat-icon>

                        </span>

                        <input formControlName="strFamily" class="form-control" type="text" placeholder=" ">

                    </div>

                </div>

                <div class="form-group w-100 has-icon mb-3">

                    <label class="text-muted m-0"> موبایل </label>


                    <span class="form-control-icon">

                        <mat-icon class="mat-18">call</mat-icon>

                    </span>

                    <input readonly (input)="filterNumericInput($event)" inputmode="numeric" maxlength="11"
                        formControlName="strMobile" class="form-control" type="text" placeholder=" ">

                </div>

                <div class="form-group w-100 has-icon mb-3">

                    <label class="text-muted m-0"> شماره حساب </label>


                    <span class="form-control-icon">

                        <mat-icon class="mat-18">account_balance</mat-icon>

                    </span>

                    <input (input)="filterNumericInput($event)" inputmode="numeric" maxlength="16"
                        formControlName="strBankAccount" class="form-control" type="text" placeholder=" ">

                </div>

                <div class="central mb-3 form_box">

                    <div class="form-group w-100 has-icon ">

                        <label class="text-muted m-0"> کد ملی </label>


                        <span class="form-control-icon">

                            <mat-icon class="mat-18">badge</mat-icon>

                        </span>

                        <input (input)="filterNumericInput($event)" inputmode="numeric" maxlength="10"
                            formControlName="strID" class="form-control" type="text" placeholder=" مثال : 0024212345">

                    </div>

                    <div class="mx-1"></div>

                    <div class="position-relative w-100  d-flex">

                        <div class="w-100" *ngIf="list_City.length">

                            <label class="text-muted m-0"> شهر </label>

                            <custom-filter 

                                [strValue]="returnStrValue('strCity',mdl_TripSAD.get('strCity')?.value,list_City,'strCityName')"

                                [strComment]="'strCityName'" 
                                
                                [stylesArray]="['padding-top: 10px','text-align: center']"

                                [str_Placeholder]="' جستجو کنید'" 
                                
                                [lst_Main]="list_City"

                                [lst_SearchKey]="['strCityName']" 
                                
                                [isDisabled]="false"

                                (hideOptions)="setValue_Filter($event,'strCity')">


                            </custom-filter>
                        </div>

                    </div>

                </div>

                <div class="position-relative col-12 mb-3">

                    <label class="text-muted"> آدرس </label>

                    <input class="form-control p-2 input-start" placeholder="آدرس دقیق همراه پلاک، بلوک و ..."
                        formControlName="strAddress">

                    <button class="btn btn-warning rounded" (click)="show_Map('strAddress')">

                        <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                    </button>

                </div>

                <app-custom-map *ngIf="showCustom_Map" [strValue]="mdl_Map.get('strAddress')?.value"
                    [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" [isOpenModal]="true"
                    (mdl_Submit)="submitMap($event)">

                </app-custom-map>


                <div class="d-flex flex-column justify-content-between w-100 mb-2 px-2">
                    <div class="central justify-content-start my-1">
                        <input class="mx-2" type="radio" formControlName="tiSex" [value]="1">
                        <mat-icon>man</mat-icon>
                        مرد
                    </div>
                    <div class="central justify-content-start my-1">
                        <input class="mx-2" type="radio" formControlName="tiSex" [value]="2">
                        <mat-icon>woman</mat-icon>
                        زن
                    </div>
                </div>



                <div class=" central w-100 justify-content-between price_offer">
                    <div>
                        <button (click)="editProfile()" class="btn btn-primary px-4">
                            ویرایش
                        </button>
                    </div>
                </div>



            </div>
            <div class="col-md-3"></div>

        </div>

    </div>

</form>